import { render, staticRenderFns } from "./SupportStrategyAcknowledgeModal.vue?vue&type=template&id=83d066fa&scoped=true"
import script from "./SupportStrategyAcknowledgeModal.vue?vue&type=script&lang=js"
export * from "./SupportStrategyAcknowledgeModal.vue?vue&type=script&lang=js"
import style0 from "./SupportStrategyAcknowledgeModal.vue?vue&type=style&index=0&id=83d066fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d066fa",
  null
  
)

export default component.exports